import React, { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import Image from 'next/image';

import { useTranslation } from 'react-i18next';

const InfoItem = ({ label, value, bold = false }) => {
  return (
    <Typography sx={{ fontFamily: 'var(--font-red-hat-display)', fontSize: '14px', color: '#3a3a3a', fontWeight: bold ? 'bold' : 'normal', mt: 1 }}>
      {label} {value}
    </Typography>
  );
};

const InformationQuote = ({ infoMutuo }) => {
  const [expandInfo, setExpandInfo] = useState(false);

  return (
    <Typography
      onClick={() => setExpandInfo(val => !val)}
      sx={[
        {
          fontFamily: 'inherit',
          fontWeight: 'bold',
          textTransform: 'uppercase',
          fontSize: '16px',
          lineHeight: '20px',
          cursor: 'pointer',
          userSelect: 'none',
        },
        !expandInfo && {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          display: '-webkit-box',
          lineClamp: '2',
          WebkitLineClamp: '2',
          WebkitBoxOrient: 'vertical',
        },
      ]}>
      {infoMutuo}
    </Typography>
  );
};

const Informativa = ({ closeFunction }) => {
  return ( <div
              className="popupContainer">
              <div
                className="popupBackground"
                onClick={() => {
                  closeFunction();
                }}></div>
              <div className="popupContent">
                <div
                  class="popupCloseButton"
                  onClick={() => {
                    closeFunction();
                  }}>
                  <img src="/pop-up-close-1.svg" />
                </div>
                <h3>Informativa prodotto mutuo</h3>
                <b>Scheda Preventivo e Prodotto Mutuo</b>
                <br />
                www.tassomutuo.it - Piattaforma online specializzata nel calcolo e confronto di mutui residenziali. Descrizione del Servizio: il
                nostro sito fornisce un servizio avanzato per il calcolo delle rate di mutuo e la comparazione delle offerte delle principali banche.
                Utilizziamo algoritmi sofisticati per stimare le condizioni finanziarie personalizzate basate su variabili quali importo del prestito,
                durata del mutuo e tasso d&#39;interesse, permettendo agli utenti di ottenere una visione preliminare delle proposte disponibili.
                <br />
                <br />
                <b>Modalità di Calcolo della Rata:</b>
                <br />
                Importo del Mutuo: quantità totale del finanziamento che l&#39;utente intende richiedere. Durata del Mutuo: numero di anni durante i
                quali il mutuo sarà ammortizzato. Tasso d&#39;Interesse: percentuale applicata per il calcolo degli interessi, che può essere fissa o
                variabile secondo le migliori offerte di mercato al momento della richiesta. <br />
                <br />
                <b>Dettagli del Preventivo:</b>
                <br />
                Rata Mensile Indicativa: valutazione approssimativa della rata mensile basata sui dati forniti dall&#39;utente e aggiornata con i
                tassi di interesse attuali delle banche. Spese Accessorie: elenco dettagliato di tutte le spese aggiuntive previste, inclusi costi di
                istruttoria, oneri per la perizia dell&#39;immobile, spese notarili, assicurazioni obbligatorie e possibili commissioni di estinzione
                anticipata. <br />
                <br />
                <b>Informazioni Legali e Avvertenze:</b>
                <br />
                Carattere Indicativo del Preventivo: si sottolinea che i risultati forniti dal nostro calcolatore sono da intendersi come una guida
                preliminare e non costituiscono un&#39;offerta vincolante. Conferma delle Condizioni: le condizioni finali del mutuo, inclusi i tassi
                definitivi e le spese totali, verranno fornite dalla banca dopo un&#39;analisi dettagliata della situazione finanziaria del
                richiedente. Responsabilità Limitata: www.tassomutuo.it declina ogni responsabilità per decisioni prese basate unicamente sulle stime
                fornite dal nostro sito. <br />
                <br />
                <b>Privacy e Trattamento dei Dati:</b>
                <br />
                I dati personali inseriti dagli utenti sono raccolti con il solo scopo di elaborare le stime richieste e non verranno utilizzati per
                altri fini senza esplicito consenso. Tutti i dati sono trattati in piena conformità con il GDPR e le normative sulla privacy italiane.
                Assistenza Clienti: offriamo un supporto completo tramite il nostro servizio clienti, disponibile via email, telefono o chat dal vivo
                per rispondere a domande, chiarire dubbi e assistere gli utenti durante l&#39;uso del nostro servizio. <br />
                <br />
                <b>Documentazione Supportiva:</b>
                <br />
                Invitiamo i nostri utenti a consultare i termini e condizioni del nostro sito per una comprensione dettagliata dei servizi offerti e
                delle normative che regolano la nostra attività. Ulteriori Informazioni: per dettagli approfonditi sulle condizioni del credito
                immobiliare, si consiglia di consultare la sezione informativa sul credito immobiliare disponibile sul sitoweb della banca
                selezionata.
              </div>
            </div>
          )
}

const DetailsInfoSection = ({ tan, taeg, duration, perizia, istruttoria, incendio }) => {
  const { t } = useTranslation();
  const [showInformativa, setShowInformativa] = useState(false);

  return (
    <Box sx={{ display: 'flex', gap: 1 }}>
      <Box flex={1}>
        {tan && <InfoItem label={t('preventivatore.tan')} value={`${tan}%`} bold />}
        {taeg && <InfoItem label={t('preventivatore.taeg')} value={`${taeg}%`} bold />}
      </Box>
      <Box flex={1}>
        {duration && <InfoItem label="Durata:" value={`${duration} anni`} />}
        <InfoItem
          label={t('preventivatore.expertise')}
          value={perizia && perizia !== '0' && perizia !== '0,00' && perizia !== '0.00' ? '€ ' + perizia : 'n.d.'}
        />
      </Box>

      <Box flex={1}>
        {istruttoria && (
          <div>
            <div className="onlydesktop">
              <InfoItem
                label={t('preventivatore.investigation_ext')}
                value={istruttoria && istruttoria !== '0' && istruttoria !== '0,00' && istruttoria !== '0.00' ? '€ ' + istruttoria : 'n.d.'}
              />
            </div>
            <div className="onlymobile">
              <InfoItem
                label={t('preventivatore.investigation')}
                value={istruttoria && istruttoria !== '0' && istruttoria !== '0,00' && istruttoria !== '0.00' ? '€ ' + istruttoria : 'n.d.'}
              />
            </div>
          </div>
        )}
        {/* {incendio && (
          <InfoItem
            label={t('preventivatore.incendio')}
            value={incendio && incendio !== '0' && incendio !== '0,00' && incendio !== '0.00' ? '€ ' + incendio : 'n.d.'}
          />
        )} */}
        <Typography sx={{ fontFamily: 'var(--font-red-hat-display)', fontSize: '14px', color: '#3a3a3a', fontWeight: 'normal', mt: 1 }}>
          <div
            style={{
              cursor: 'pointer',
              textDecoration: 'underline',
            }}
            onClick={() => {
              setShowInformativa(true);
            }}>
            {t('preventivatore.informativa')}
          </div>
          {showInformativa && (
            <Informativa
              closeFunction={() => {
                setShowInformativa(false);
              }}
            />
          )}
        </Typography>
      </Box>
    </Box>
  );
};

const CtaSection = ({ onCtaClick }) => {
  return (
    <>
      <Button
        className="estimator-list-button"
        variant="contained"
        onClick={onCtaClick}
        sx={{
          width: '100%',
          maxWidth: '300px',
          borderRadius: 0,
          fontWeight: 'bold',
          boxShadow: 'none',
          cursor: 'pointer',
          backgroundColor: '#00871A',
          my: 2,
          p: 1,
          fontSize: '16px',
          whiteSpace: 'normal', // Allow text wrapping
          textAlign: 'center', // Center align text
          '&:hover': {
            backgroundColor: '#ffffff',
            border: '1px solid #00871A',
            cursor: 'pointer',
            boxShadow: 'none',
          },
        }}>
        Verifica fattibilità
      </Button>
      <Typography
        className="buttonsubline"
        sx={{
          fontFamily: 'inherit',
          fontSize: 'inherit',
          textAlign: 'center',
          fontWeight: 'bold',
          color: '#00871A',
          whiteSpace: 'normal', // Allow text wrapping
        }}>
        GRATIS E SENZA IMPEGNO
      </Typography>
    </>
  );
};

const CardResultQuotation = ({ rata, duration, tan, taeg, infoMutuo, bankName, bankImage, perizia, istruttoria, incendio, onCtaClick }) => {
  const bankLogo = bankImage.replace('http://', 'https://');
  return (
    <>
      {/* CARD DESKTOP */}
      <Box
        sx={{
          display: { xs: 'none', md: 'flex' },
          justifyContent: 'space-between',
          border: 'solid 1px #DFE3E8',
          p: 2,
          fontFamily: 'var(--font-red-hat-display)',
          fontSize: '14px',
          color: '#3a3a3a',
          gap: 2,
        }}>
        <Box sx={{ width: '20%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', gap: 2 }}>
          <Box
            sx={{
              objectFit: 'contain',
              maxWidth: { xs: '140px', sm: '200px', md: '200px' },
              maxHeight: '40px',
              display: 'flex',
              justifyContent: 'start',
            }}>
            <Image
              src={bankLogo}
              alt={`Preventivo mutuo ${bankName || 'richiesto'}`}
              width={1280}
              height={526}
              style={{ objectPosition: 'left center', objectFit: 'contain', maxWidth: '100%', maxHeight: '100%', height: '100%', width: 'auto' }}
            />
          </Box>

          <Box mt={2}>
            <Typography sx={{ fontFamily: 'inherit', color: 'inherit', fontSize: '14px' }}>Importo rata</Typography>
            <Typography
              sx={{
                fontFamily: 'inherit',
                color: '#0A92DE',
                fontWeight: 'bold',
                fontSize: '33px',
                lineHeight: '33px',
                letterSpacing: '1px',
              }}>
              € {rata}
            </Typography>
          </Box>
        </Box>
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between', gap: 2 }}>
          <InformationQuote infoMutuo={infoMutuo} />
          <DetailsInfoSection perizia={perizia} taeg={taeg} duration={duration} tan={tan} incendio={incendio} istruttoria={istruttoria} />
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', width: '20%' }}>
          <CtaSection onCtaClick={onCtaClick} />
        </Box>
      </Box>

      {/* CARD MOBILE */}
      <Box
        sx={{
          display: { xs: 'flex', md: 'none' },
          flexDirection: 'column',
          justifyContent: 'space-between',
          border: 'solid 1px #DFE3E8',
          p: 2,
          fontFamily: 'var(--font-red-hat-display)',
          fontSize: '14px',
          color: '#3a3a3a',
          gap: 2,
          boxShadow: '0px 0px 15px #00000040',
          maxWidth: '450px',
          margin: '0 auto',
          my: 3,
        }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', mb: 2 }}>
          <Box
            sx={{
              objectFit: 'contain',
              maxWidth: { xs: '140px', sm: '200px', md: '200px' },
              maxHeight: '40px',
              display: 'flex',
              justifyContent: 'start',
            }}>
            <Image
              src={bankLogo}
              alt={`Preventivo mutuo ${bankName || 'richiesto'}`}
              width={1280}
              height={526}
              style={{ objectPosition: 'left center', objectFit: 'contain', maxWidth: '100%', maxHeight: '100%', height: '100%', width: 'auto' }}
            />
          </Box>
          <Box>
            <Typography sx={{ fontFamily: 'inherit', color: 'inherit', fontSize: '14px' }}>Importo rata</Typography>
            <Typography
              sx={{
                fontFamily: 'inherit',
                color: '#0A92DE',
                fontWeight: 'bold',
                fontSize: '28px',
                lineHeight: '28px',
                letterSpacing: '1px',
              }}>
              € {rata}
            </Typography>
          </Box>
        </Box>
        <InformationQuote infoMutuo={infoMutuo} />
        <DetailsInfoSection perizia={perizia} taeg={taeg} duration={duration} tan={tan} incendio={incendio} istruttoria={istruttoria} />
        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', width: '100%' }}>
          <CtaSection onCtaClick={onCtaClick} />
        </Box>
      </Box>
    </>
  );
};

export default CardResultQuotation;
